module.exports = __webpack_public_path__ + "assets/06a26ac95c04214ada69781a87938fb3.mp4";